import Plyr from 'plyr';

import Utils from './helpers/utils.js';
import AccordionHelper from './helpers/accordion-helper.js';

import GlideSlideshow from './components/glide-slideshow.js';
import Menu from './components/menu.js';
import ActivitiesMap from './components/activities-map.js';
import PrevEditions from './components/prev-editions.js';

window.ENV = {
  GOOGLE_MAPS_API_KEY: 'AIzaSyC8Ho2yCryqgiTC3gVMDM64-OyVGAYqtPA', //TODO via env
};


Utils.docReady(() => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--mobile-menu-height', `${ getMenuMobileHeight() > 0 ? (getMenuMobileHeight() * -1) : (window.innerHeight * -1) }px`);

  /** Accordions **/
  const accordionObjs = [];
  document.querySelectorAll('.ma-accordion').forEach( function(el) {
    const accordionObj = new AccordionHelper(el, true, null, null, null, null, null, function(){
      accordionObjs.forEach(function(object) {
        if(object.states.state == 'open' && object != accordionObj)
          object.close();
      });
    });

    accordionObj.init();

    accordionObjs.push(accordionObj);
  });

  new Menu;

  document.querySelectorAll('[data-glide]').forEach(el => {
    new GlideSlideshow(el, {autoplay: el.hasAttribute('data-autoplay')});
  });

  document.querySelectorAll('[data-plyr]').forEach(el => {
    const plyr = new Plyr(el, {tooltips: false, invertTime: false, controls: ['play', 'progress', 'mute', 'fullscreen']});
  });

  document.querySelectorAll('[data-thumb-thumbnail]').forEach(el => {
    const thumbUrl = el.getAttribute('data-thumb-thumbnail');
    if(!thumbUrl)
      return;

    const thumbImgEl = document.querySelector('.block-artists__img-thumb');

    el.addEventListener('mouseenter', () => {
      if(Utils.isMobileView())
        return;
      thumbImgEl.innerHTML = `<img src="${thumbUrl}">`;
    });
    el.addEventListener('mouseleave', () => {
      if(Utils.isMobileView())
        return;
      thumbImgEl.innerHTML = '';
    });
  });

  const mapEl = document.querySelector('[data-activities-map]');
  if(mapEl)
    new ActivitiesMap(mapEl)


  const prevEditionsEl = document.querySelector('[data-prev-editions]');
  if(prevEditionsEl) {
    new PrevEditions(prevEditionsEl);
  }
});


window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--mobile-menu-height', `${ getMenuMobileHeight() > 0 ? (getMenuMobileHeight() * -1) : (window.innerHeight * -1) }px`);
});




const getMenuMobileHeight = function() {
  return document.querySelector('.menu-mobile__fixed').getBoundingClientRect().height * document.querySelectorAll('.menu-mobile__nav > li').length;
}
